import { render, staticRenderFns } from "./GroupTableMenu.vue?vue&type=template&id=4065cff2&"
import script from "./GroupTableMenu.vue?vue&type=script&lang=js&"
export * from "./GroupTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports